// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {buildDate} from '../../../../shared/services/build-date';

const AmountOfUseHistoryPanelItem = props =>
    <section className='amount-of-use-history-item'>
        <span className='date'>{buildDate(props.date)}</span>
        <span className='description'>{props.description}</span>
        <span className='amount-recorded'>{props.amountRecorded}</span>
        <span className='unit'>{props.unit}</span>
    </section>;

AmountOfUseHistoryPanelItem.displayName = 'AmountOfUseHistoryPanelItem';
AmountOfUseHistoryPanelItem.propTypes = {
    amountRecorded: PropTypes.number.isRequired,
    date: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    unit: PropTypes.string.isRequired
};

export default AmountOfUseHistoryPanelItem;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-history-panel-item.js